import { Params } from 'react-router-dom';
import { UserUI } from '@shared';
import { RouteEnum, generateRoutePath } from 'App';

const { REACT_APP_URL } = process.env;

export function scrollToNewElement(id: string) {
  setTimeout(() => {
    // setTimeout to execute after rendering new li element
    const list = document.querySelectorAll(`#${id}`);
    const lastElement = list[list.length - 1];
    lastElement.scrollIntoView(true);
  });
}

export const generateBreadcrumbsData = (
  data: { path: { name: RouteEnum; params?: Params<string> }; name: string }[]
) =>
  data.map((breadcrumbData) => ({
    path: generateRoutePath({ name: breadcrumbData.path.name, params: breadcrumbData.path.params }),
    name: breadcrumbData.name,
  }));
export const pickupStreamServiceURL = () => {
  const isStaging = REACT_APP_URL?.includes('staging-auditor');
  const isQa = REACT_APP_URL?.includes('qa-auditor');
  const isLocal = REACT_APP_URL?.includes('localhost');
  if (isStaging) {
    return 'https://staging-stream-ui.proctorfree.com';
  } else if (isQa || isLocal) {
    return 'https://qa-stream-ui.proctorfree.com';
  } else {
    return 'https://stream-ui.proctorfree.com';
  }
};

const checkOnlyInstructor = ({ isInstructor, isAuditor, isLeadAuditor }: UserUI['roles']) =>
  isInstructor && !isAuditor && !isLeadAuditor;

export const getInitialPage = (currentUser: UserUI) => {
  const isOnlyInstructor = checkOnlyInstructor(currentUser.roles);
  return {
    pathname: generateRoutePath({
      name: isOnlyInstructor ? RouteEnum.Courses : RouteEnum.AuditQueue,
      params: isOnlyInstructor ? { partner: currentUser.partnerUUIDs[0] } : undefined,
    }),
  };
};
